module.exports = __webpack_public_path__ + "img/step4-b.83a3e08d.png";